import React, { FC } from 'react'
import { cloneDeep } from 'lodash'
import { ADDRESS_TYPE, FIELDS_FIAS } from 'Src/constants/Address.constants'
import { getStringSource } from 'Helpers'
import Form, { FormComponentProps } from 'antd/lib/form'
import { FieldNames } from 'Constants/FieldNames'
import { FormNames } from 'Constants/FormNames'
import { SelectItem } from 'Types/item'
import { AddressSuggest } from 'Models'
import { SelectValue } from 'LibNeo'
import { AddressEditFiasFieldComponent } from './AddressEditFiasField.component'

interface AddressEditFiasProps extends FormComponentProps {
	initialData: AddressSuggest
	saveEditAddress: (address: AddressSuggest) => void
	disabled?: boolean
	isJuridical?: boolean
	typeAddress?: ADDRESS_TYPE
}

export const AddressEditFias: FC<AddressEditFiasProps> = ({
	form,
	initialData,
	saveEditAddress,
	disabled,
	isJuridical = false,
	typeAddress,
}) => {
	const saveAddress = (value: SelectValue<SelectItem>, field: FieldNames) => {
		const newAddress = cloneDeep(initialData)
		newAddress[field] = value
		newAddress.result = getStringSource(newAddress, typeAddress)
		saveEditAddress(newAddress)
	}

	return (
		<div>
			{FIELDS_FIAS.map((field) => (
				<AddressEditFiasFieldComponent
					key={`fias-${field}`}
					field={field}
					form={form}
					disabled={disabled}
					initialData={initialData}
					saveAddress={saveAddress}
					placeholderInput="Не указано"
					placeholderSelect="Не указано"
					isJuridical={isJuridical}
					typeAddress={typeAddress}
				/>
			))}
		</div>
	)
}

export const AddressEditFiasComponent = Form.create<AddressEditFiasProps>({
	name: FormNames.EDIT_ADDRESS_FIAS_RBIDOS_REQUEST_FORM,
})(AddressEditFias)
